// extracted by css-extract-rspack-plugin
export default {"cls1":"blurred_takeaways-cls1_oyj","cls2":"blurred_takeaways-cls2_fOQ blurred_takeaways-cls1_oyj"};